export const tupayTheme = {
  fontFamily1: 'Myriad Pro Regular',
  fontFamily2: 'Myriad Pro Bold',
  fontFamily3: 'Myriad Pro Semi Bold',
  fontFamily4: 'Myriad Pro Italic',
  primary: '#273DB5',
  primeraryActive: '#331487',
  secondary: '#e07900',
  h1: {
    color: '#233db4',
    fontSize: '30px',
    lineHeight: '1.27',
    fontFamily: 'Myriad Pro Regular',
  },
  success: '#96df7a',
  info: '#3bcfd5',
  warning: '#f3b258',
  danger: '#dd3570',
  dark: '#2a294',
  activeColor: '#fff',
  contrastActiveColor: '#4a4a48',
  secondColor: '#515084',
  loaderFirst: '#7EE16B',
  loaderSecond: '#515084',
  loaderThird: '#014ed8',
  loginInputsWidth: '80%',
  homeWelcomeFb: '2%',
  loginButtonSubmitColor: '#fff',
  loginButtonSubmitBackgroundColor: '#233db4',
  loginButtonSubmitBorderColor: '#233db4',
  loginButtonSubmitBorderwidth: '60%',
  loginButtonSubmitFocusColor: '#495057',
  forgotPasswordFontSize: '12px',
  tupayColor: '#233db4',
  buttonDarkColor: '#fff',
  inputColor: 'red',
  badgeMarginTop: '-39px',
  LoginLayoutClasses: {
    gridColumnsRight: 'col-lg-6',
    gridColumnsLeft: 'col-lg-6',
    welcomeText: 'px-2 px-xl-5 py-2',
    homeWelcomeAlign: 'text-center',
    form: 'px-xl-5 d-flex flex-column justify-content-center align-items-center',
    buttonSubmit: 'form-control btn btn-blue mt-3 text-uppercase',
    buttonMfa: 'form-control btn btn-dark mt-3 text-uppercase',
    buttonsignIn: 'form-control btn btn-dark mt-3 text-uppercase',
  },
  signUpClasses: {
    buttonCancel: 'btn btn-ghost',
    buttonSave: 'btn btn-blue'
  }
};
